"use client";

import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function Philosophy() {
  const {
    ref: headlineRef,
    isVisible: headlineVisible
  } = useRevealOnScroll<HTMLHeadingElement>({
    threshold: 0.15
  });
  const {
    ref: bodyRef,
    isVisible: bodyVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.15
  });
  const headlineWords = [{
    text: "We",
    italic: false
  }, {
    text: "churn",
    italic: false
  }, {
    text: "flavors",
    italic: false
  }, {
    text: "that",
    italic: false
  }, {
    text: "redefine",
    italic: true
  }, {
    text: "the",
    italic: false
  }, {
    text: "scoop.",
    italic: false
  }];
  return <section data-section-id="17101" id="the-artisanal-philosophy" className="bg-background py-32 md:py-44 lg:py-52 overflow-hidden">
      <div className="mx-auto max-w-[1480px] px-5 sm:px-8 lg:px-14">
        <div className="grid grid-cols-1 lg:grid-cols-12 lg:gap-6">
          {}
          <div className="lg:col-span-7 lg:-ml-6">
            <h2 ref={headlineRef} className="font-serif text-foreground font-[500] leading-[0.9] tracking-tight" style={{
            fontSize: "clamp(3rem, 9vw, 9.5rem)",
            letterSpacing: "-0.035em"
          }}>
              {headlineWords.map((word, i) => <span key={i} data-index={i} className="inline-block overflow-hidden align-bottom mr-[0.22em]">
                  <span className={`inline-block transition-all ease-[cubic-bezier(0.2,0.8,0.2,1)] ${word.italic ? "italic font-[400]" : ""}`} style={{
                transitionDuration: "900ms",
                transitionDelay: `${i * 60 + (word.italic ? 80 : 0)}ms`,
                transform: headlineVisible ? "translateY(0)" : "translateY(110%)",
                opacity: headlineVisible ? 1 : 0
              }}>
                    {word.text}
                  </span>
                </span>)}
            </h2>
          </div>

          {}
          <div ref={bodyRef} className="lg:col-span-5 lg:flex lg:flex-col lg:justify-center mt-12 lg:mt-0" style={{
          opacity: bodyVisible ? 1 : 0,
          transform: bodyVisible ? "translateY(0)" : "translateY(16px)",
          transition: "opacity 700ms ease-out 120ms, transform 700ms ease-out 120ms"
        }}>
            <div className="max-w-[38ch] space-y-6">
              <p className="font-default text-foreground font-normal leading-[1.55]" style={{
              fontSize: "clamp(1.125rem, 1.25vw, 1.375rem)",
              letterSpacing: "-0.005em"
            }}>
                SCOOP creates artisanal ice cream for the modern palate — 
                blending heritage techniques with bold, contemporary ingredients 
                to craft a sensory experience that lingers long after the final bite.
              </p>
              <p className="font-default text-foreground font-normal leading-[1.55]" style={{
              fontSize: "clamp(1.125rem, 1.25vw, 1.375rem)",
              letterSpacing: "-0.005em"
            }}>
                We source only the finest seasonal elements, transforming 
                simple dairy into a canvas of vibrant color and texture, 
                designed to be savored as a true culinary masterpiece.
              </p>

              <div className="pt-4">
                <Link to="/TheArtisanalProcessPage" className="group inline-flex items-center gap-2 font-default font-medium text-primary text-base underline underline-offset-[6px] decoration-1 decoration-primary transition-colors duration-[240ms] hover:decoration-foreground hover:text-foreground">
                  <span>Discover our process</span>
                  <ArrowRight className="size-4 transition-transform duration-[240ms] group-hover:translate-x-1" aria-hidden="true" />
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}